import { application } from "../application"

import FavoriteController from "../favorite_controller"
application.register("favorite", FavoriteController)

import FluctStickyAdController from "../fluct_sticky_ad_controller"
application.register("fluct-sticky-ad", FluctStickyAdController)

import RecentlyStocksController from "../recently_stocks_controller"
application.register("recently-stocks", RecentlyStocksController)

import SmoothScrollController from "../smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import SessionMonitorController from "../session_monitor_controller"
application.register("session-monitor", SessionMonitorController)

import JsLazyLoadingController from "../js_lazy_loading_controller"
application.register("js-lazy-loading", JsLazyLoadingController)

import FavBtnsController from "../fav_btns_controller"
application.register("fav-btns", FavBtnsController)
